import { Component, OnInit, Input } from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import { BookResult } from 'src/app/models/api_models/book';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent implements OnInit {
  private _bookList : BookResult[]= null;
  get bookList() : BookResult[] {
    return this._bookList;
  }

  @Input()
  set bookList(bookList : BookResult[]) {
    this._bookList = bookList;
    if (this._bookList !== null) {
//      this.dataSource = new MatTableDataSource(this._bookList);
    }
  }

  panelOpenState: boolean = false;

  togglePanel() {
      this.panelOpenState = !this.panelOpenState
  }
  constructor() { }

  
  ngOnInit() {
  }

}
